/*
 * Helper de exibição do SCORE de um candidato (FE-3 CP-C).
 *
 * Vive num módulo próprio (não em `FilaConciliacao.tsx`/`ConfirmacaoConciliacao.tsx`)
 * pela mesma razão do `cnpj.ts`: o `react-refresh/only-export-components` exige
 * que um arquivo de componente exporte SÓ componentes. Como este helper precisa
 * ser exportado para teste unitário, isolá-lo aqui mantém o Fast Refresh são.
 *
 * IMPORTANTE: o score NÃO é valor financeiro — é a CONFIANÇA do casamento (0–1).
 * Por isso `Number` é aceitável aqui (não é `NUMERIC(18,2)` monetário, não há
 * exigência de precisão decimal exata). Para valores monetários, jamais `Number`
 * (ver `lib/formato/decimal`).
 */

const SEM_VALOR = "—";

/**
 * Formata o score de confiança (string `"0..1"` ou `null`) como percentual inteiro.
 *
 * `null` → "—" (candidato sem score). Caso contrário, `"0.87"` → "87%",
 * `"0.5"` → "50%", `"1"` → "100%". Arredonda ao inteiro (`Math.round`).
 */
export function formatarScore(score: string | null): string {
  if (score === null) {
    return SEM_VALOR;
  }
  return `${Math.round(Number(score) * 100)}%`;
}
